import { render, staticRenderFns } from "./received-new-ux.vue?vue&type=template&id=2da6055c&"
import script from "./received-new-ux.vue?vue&type=script&lang=js&"
export * from "./received-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da6055c')) {
      api.createRecord('2da6055c', component.options)
    } else {
      api.reload('2da6055c', component.options)
    }
    module.hot.accept("./received-new-ux.vue?vue&type=template&id=2da6055c&", function () {
      api.rerender('2da6055c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/received-new-ux.vue"
export default component.exports